import { SearchIcon } from '@/icons';
import { cn } from '@/lib/cn';
import { Input } from 'antd';
import type { ChangeEvent } from 'react';

type Props = {
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

/** The search box used in every payroll toolbar. Debouncing is the caller's. */
const SearchInput = ({ placeholder, onChange, className }: Props) => (
  <Input
    size="large"
    onChange={onChange}
    placeholder={placeholder}
    className={cn('shrink-0 w-[225px]', className)}
    prefix={<SearchIcon size={24} />}
  />
);

export default SearchInput;
